import * as React from 'react';

import { get as userGet } from 'js/lib/user';

import LegacyEnterpriseReturnToProgramBanner from 'bundles/composable-page-header-consumer/banners/LegacyEnterpriseReturnToProgramBanner';
import LegacyGetS12nCertBannerWrapper from 'bundles/composable-page-header-consumer/banners/LegacyGetS12nCertBannerWrapper';
import LegacyProductDiscountPromoBannerWrapper from 'bundles/composable-page-header-consumer/banners/LegacyProductDiscountPromoBannerWrapper';
import { useConsumerMyPageHeader } from 'bundles/composable-page-header-consumer/contexts/ConsumerMyPageHeaderContext';
import DegreeLearnerOnConsumerDesktopMainNav from 'bundles/composable-page-header-consumer/main-nav-modules/desktop/DegreeLearnerOnConsumerDesktopMainNav';
import EnterpriseLearnerOnConsumerDesktopMainNav from 'bundles/composable-page-header-consumer/main-nav-modules/desktop/EnterpriseLearnerOnConsumerDesktopMainNav';
import LoggedInConsumerDesktopMainNav from 'bundles/composable-page-header-consumer/main-nav-modules/desktop/LoggedInConsumerDesktopMainNav';
import LoggedOutConsumerDesktopMainNav from 'bundles/composable-page-header-consumer/main-nav-modules/desktop/LoggedOutConsumerDesktopMainNav';
import AlternateLearnerOnConsumerMobileMainNav from 'bundles/composable-page-header-consumer/main-nav-modules/mobile/AlternateLearnerOnConsumerMobileMainNav';
import LoggedInConsumerWithMetaNavLinksMobileMainNav from 'bundles/composable-page-header-consumer/main-nav-modules/mobile/LoggedInConsumerWithMetaNavLinksMobileMainNav';
import LoggedOutConsumerMobileMainNav from 'bundles/composable-page-header-consumer/main-nav-modules/mobile/LoggedOutConsumerMobileMainNav';
import DefaultConsumerPageHeaderProvider from 'bundles/composable-page-header-consumer/providers/DefaultConsumerPageHeaderProvider';
import LegacyGDPRBannerWrapper from 'bundles/composable-page-header/banners/LegacyGDPRBannerWrapper';
import GlobalPageHeaderContainer from 'bundles/composable-page-header/components/GlobalPageHeaderContainer';
import DefaultMetaNavigation from 'bundles/composable-page-header/components/meta-nav/DefaultMetaNavigation';
import { DEFAULT_META_NAV_HEIGHT } from 'bundles/composable-page-header/constants';
import GlobalPageHeaderStateProvider from 'bundles/composable-page-header/providers/GlobalPageHeaderStateProvider';

const ProductDescriptionPageHeader = () => {
  const { chosenEnterpriseProgram, chosenDegree } = useConsumerMyPageHeader();
  const user = userGet();

  const getDesktopNav = () => {
    if (user?.id && !!chosenEnterpriseProgram) {
      return EnterpriseLearnerOnConsumerDesktopMainNav;
    } else if (user?.id && !!chosenDegree) {
      return DegreeLearnerOnConsumerDesktopMainNav;
    } else if (user?.id) {
      return LoggedInConsumerDesktopMainNav;
    } else {
      return LoggedOutConsumerDesktopMainNav;
    }
  };
  const getMobileNav = () => {
    if (user?.id && (!!chosenEnterpriseProgram || !!chosenDegree)) {
      return AlternateLearnerOnConsumerMobileMainNav;
    } else if (user?.id) {
      return LoggedInConsumerWithMetaNavLinksMobileMainNav;
    } else {
      return LoggedOutConsumerMobileMainNav;
    }
  };

  const DesktopNavComponent = getDesktopNav();
  const MobileNavComponent = getMobileNav();

  return (
    <GlobalPageHeaderContainer
      desktopMainNav={<DesktopNavComponent />}
      mobileMainNav={<MobileNavComponent />}
      metaNav={<DefaultMetaNavigation />}
      scrollMovementOffset={{
        desktop: DEFAULT_META_NAV_HEIGHT,
        mobile: 0,
      }}
      banners={[
        { name: 'GDPRBanner', component: <LegacyGDPRBannerWrapper /> },
        { name: 'ProductDiscountPromoBanner', component: <LegacyProductDiscountPromoBannerWrapper /> },
        { name: 'GetS12nCertBanner', component: <LegacyGetS12nCertBannerWrapper /> },
        { name: 'EnterpriseReturnToProgramBanner', component: <LegacyEnterpriseReturnToProgramBanner /> },
      ]}
    />
  );
};

const ProductDescriptionPageHeaderWithProvider = () => {
  return (
    <GlobalPageHeaderStateProvider additionalDefaultPageHeaderHeight={DEFAULT_META_NAV_HEIGHT}>
      <DefaultConsumerPageHeaderProvider>
        <ProductDescriptionPageHeader />
      </DefaultConsumerPageHeaderProvider>
    </GlobalPageHeaderStateProvider>
  );
};

export default ProductDescriptionPageHeaderWithProvider;
